import on from '../on';
import regenerateAtomicCSS from './regenerate-atomic-css';
import reasons from '../../constants/reasons';

const { SET_ELEMENT_ATTRIBUTE, PASTE_ELEMENT } = reasons;

const init = () => {
  on({ reason: SET_ELEMENT_ATTRIBUTE }, regenerateAtomicCSS);
  on({ reason: PASTE_ELEMENT }, regenerateAtomicCSS);
};

export default init;
